/**
 * 한국어 번역
 * Korean Translation
 */

const koKRTranslations = {
  app: {
    title: '야근 관리 도구',
    subtitle: '야근 관리 시스템',
    description: '전문적인 야근 기록 및 대휴 관리 도구'
  },

  // 날짜 시간 관련
  dateTime: {
    invalidDate: '유효하지 않은 날짜',
    formatError: '날짜 형식 오류'
  },

  common: {
    confirm: '확인',
    cancel: '취소',
    save: '저장',
    delete: '삭제',
    edit: '편집',
    copy: '복사',
    close: '닫기',
    loading: '로딩 중...',
    success: '성공',
    error: '오류',
    warning: '경고',
    info: '정보',
    yes: '예',
    no: '아니오',
    ok: '확인',
    back: '뒤로',
    next: '다음',
    previous: '이전',
    submit: '제출',
    reset: '재설정',
    clear: '지우기',
    search: '검색',
    filter: '필터',
    sort: '정렬',
    export: '내보내기',
    import: '가져오기',
    settings: '설정',
    help: '도움말',
    about: '정보'
  },
  
  time: {
    startTime: '시작 시간',
    endTime: '종료 시간',
    duration: '기간',
    totalTime: '총 시간',
    remainingTime: '남은 시간',
    usedTime: '사용된 시간',
    availableTime: '사용 가능한 시간',
    hours: '시간',
    minutes: '분',
    days: '일',
    today: '오늘',
    yesterday: '어제',
    thisWeek: '이번 주',
    thisMonth: '이번 달',
    thisYear: '올해'
  },
  
  overtime: {
    title: '야근 기록',
    record: '야근 기록',
    startTime: '야근 시작 시간',
    endTime: '야근 종료 시간',
    duration: '야근 시간',
    remaining: '남은 대휴 시간',
    total: '총 야근 시간',
    list: '야근 기록 목록',
    details: '상세 기록',
    consumption: '소비 기록',
    edit: '야근 기록 편집',
    delete: '야근 기록 삭제',
    copy: '기록 복사',
    
    validation: {
      startTimeRequired: '야근 시작 시간을 입력해주세요!',
      endTimeRequired: '야근 종료 시간을 입력해주세요!',
      endTimeAfterStart: '야근 종료 시간은 시작 시간보다 늦어야 합니다!'
    },
    
    stats: {
      totalHours: '올해 {{hours}}시간의 야근을 했습니다',
      remainingHours: '남은 대휴 시간: {{overtimeHours}}+{{annualLeaveHours}}시간'
    }
  },
  
  rest: {
    title: '대휴 기록',
    record: '대휴 신청',
    startTime: '대휴 시작 시간',
    endTime: '대휴 종료 시간',
    duration: '대휴 시간',
    type: '대휴 유형',
    compTime: '대휴',
    list: '대휴 기록 목록',
    edit: '대휴 기록 편집',
    delete: '대휴 기록 삭제',
    
    validation: {
      startTimeRequired: '대휴 시작 시간과 종료 시간을 입력해주세요!',
      endTimeRequired: '대휴 종료 시간을 입력해주세요!',
      endTimeAfterStart: '대휴 종료 시간은 시작 시간보다 늦어야 합니다!',
      insufficientTime: '이 대휴 신청에 대한 남은 시간이 부족합니다!',
      insufficientOvertimeTime: '대휴 시간을 늘리기 위한 야근 시간이 부족합니다!'
    }
  },
  
  annualLeave: {
    title: '연차 관리',
    totalDays: '총 연차 일수',
    usedHours: '사용된 시간',
    remainingHours: '남은 시간',
    record: '연차 기록',
    set: '연차 설정',
    edit: '연차 기록 편집',
    delete: '연차 기록 삭제',
    
    settings: {
      title: '연차 설정',
      totalDaysLabel: '총 연차 일수',
      totalDaysPlaceholder: '총 연차 일수를 입력하세요',
      note: '참고: 연차는 하루 8시간으로 계산됩니다'
    }
  },
  
  rules: {
    title: '계산 규칙',
    overtime: {
      title: '야근 계산 규칙',
      description: '연속 시간으로 계산, 점심시간 포함',
      example: '예: {{timeRange}} = {{result}}',
      note: '야근 시간은 실제 연속 시간으로 계산, 점심시간은 차감되지 않음'
    },
    rest: {
      title: '대휴 계산 규칙',
      description: '근무일로 계산, 점심시간 차감',
      example: '예: {{timeRange}} = {{result}} ({{note}})',
      note: '1시간 점심시간 차감',
      workingHours: '근무시간: 9:00-18:00 (12:00-13:00 점심시간 제외)'
    },
    annualLeave: {
      title: '연차 계산 규칙',
      description: '연차는 하루 8시간으로 계산',
      example: '연차 1일 = 8시간'
    }
  },
  
  data: {
    save: '데이터를 로컬에 저장',
    load: '백업 데이터 로드',
    export: '데이터 내보내기',
    import: '데이터 가져오기',
    backup: '데이터 백업',
    restore: '데이터 복원',
    clear: '데이터 지우기',
    
    messages: {
      saveSuccess: '데이터가 성공적으로 저장되었습니다',
      loadSuccess: '데이터가 성공적으로 가져와지고 업데이트되었습니다',
      exportSuccess: '데이터가 성공적으로 내보내졌습니다',
      importSuccess: '데이터가 성공적으로 가져와졌습니다',
      clearSuccess: '데이터가 성공적으로 지워졌습니다',
      parseError: '가져온 파일을 파싱할 수 없습니다. 유효한 형식인지 확인해주세요.',
      newerDataWarning: '가져온 데이터가 로컬 데이터보다 오래되었습니다. 그래도 로컬 데이터를 덮어쓰시겠습니까?',
      cleanupComplete: '정리가 완료되었습니다. {{count}}개의 중복 기록이 제거되었습니다.'
    }
  },
  
  table: {
    index: '인덱스',
    number: '번호',
    type: '유형',
    startTime: '시작 시간',
    endTime: '종료 시간',
    duration: '기간',
    remaining: '남은',
    remainingTime: '남은 휴식 가능 시간',
    actions: '작업',
    details: '상세 기록',
    expand: '펼치기',
    collapse: '접기',
    noData: '데이터 없음',
    consumptionRecords: '대휴 소비 기록',
    restRequestStartTime: '대휴 신청 시작 시간',
    restRequestEndTime: '대휴 신청 종료 시간',
    actualConsumptionStartTime: '실제 소비 시작 시간',
    actualConsumptionEndTime: '실제 소비 종료 시간',
    deductionTime: '대휴 차감 시간',
    annualLeaveStartTime: '연차 시작 시간',
    annualLeaveEndTime: '연차 종료 시간',

    pagination: {
      total: '총 {{total}}개 항목',
      pageSize: '페이지당 항목 수',
      items: '항목',
      page: '페이지'
    }
  },
  
  consumption: {
    title: '대휴 소비 기록',
    restStartTime: '대휴 신청 시작 시간',
    restEndTime: '대휴 신청 종료 시간',
    actualStartTime: '실제 소비 시작 시간',
    actualEndTime: '실제 소비 종료 시간',
    deductionTime: '대휴 차감 시간',
    type: '유형',
    
    copyReport: {
      overtimeDeduction: '해당 야근 시간 차감 ({{hours}}시간)',
      annualLeaveDeduction: '연차 시간 차감 ({{hours}}시간)',
      copySuccess: '클립보드에 복사되었습니다',
      copyFailed: '복사에 실패했습니다. 다시 시도해주세요'
    }
  },
  
  updateLog: {
    title: '업데이트 로그',
    show: '업데이트 로그 표시',
    hide: '업데이트 로그 숨기기',
    version: '버전',
    date: '날짜',
    content: '업데이트 내용'
  },
  
  language: {
    title: '언어 설정',
    current: '현재 언어',
    select: '언어 선택',
    change: '언어 변경'
  },
  
  errors: {
    networkError: '네트워크 오류, 연결을 확인해주세요',
    serverError: '서버 오류, 나중에 다시 시도해주세요',
    unknownError: '알 수 없는 오류, 관리자에게 문의해주세요',
    validationError: '데이터 검증 실패',
    permissionDenied: '권한이 거부되었습니다',
    notFound: '데이터를 찾을 수 없습니다',
    timeout: '요청 시간 초과, 다시 시도해주세요'
  },
  
  confirmDialog: {
    deleteTitle: '삭제 확인',
    deleteMessage: '이 기록을 삭제하시겠습니까?',
    clearTitle: '지우기 확인',
    cleanupMessage: '중복 데이터를 정리하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    overwriteTitle: '덮어쓰기 확인',
    overwriteMessage: '로컬 데이터가 덮어써집니다. 계속하시겠습니까?',
    deleteRestMessage: '이 휴식 기록을 삭제하시겠습니까?',
    deleteAnnualLeaveMessage: '이 연차 기록을 삭제하시겠습니까?'
  },

  // 기록 관련
  records: {
    overtimeRecords: '야근 기록',
    restRecords: '휴식 기록',
    annualLeaveRecords: '연차 기록',
    restType: '휴식',
    annualLeaveType: '연차',
    annualLeave: '연차',
    rest: '휴식',
    overtime: '야근'
  },

  // 페이지네이션
  pagination: {
    previous: '이전',
    next: '다음',
    pageInfo: '{{current}}페이지 / {{total}}페이지',
    itemsPerPage: '{{count}}개/페이지'
  },



  // 복사 기능
  copy: {
    deductOvertimeTotal: '야근 대체휴가, 야근 시간 차감 ({{hours}}시간)',
    deductAnnualLeaveTotal: '연차 시간 차감 ({{hours}}시간)',
    annualLeaveTitle: '연차 휴가:',
    errorPrefix: '텍스트를 복사할 수 없습니다: '
  },

  // 통계
  stats: {
    totalOvertime: '총 사축 시간',
    availableOvertime: '사용 가능한 사축 시간',
    remainingAnnualLeave: '남은 대휴가 시간',
    totalRest: '총 빈둥거림 시간'
  },

  // 작업
  actions: {
    recordOvertime: '사축 이벤트 기록',
    addOvertimeTime: '사축 기록 추가',
    requestRest: '빈둥거림 신청',
    useOvertimeTime: '빈둥거림 시작~~',
    setAnnualLeave: '대휴가 시간 설정',
    configureAnnualLeaveDays: '연도별 대휴가 시간 설정',
    recordAnnualLeave: '대휴가 시간 기록',
    saveData: '사축 기록 저장',
    exportData: '사축 기록 내보내기',
    importData: '사축 기록 가져오기',
    cleanData: '중복 사축 기록 정리'
  },

  // 메시지
  messages: {
    overtimeAdded: '야근 기록이 추가되었습니다',
    restAdded: '휴식 기록이 추가되었습니다',
    overtimeDeleted: '야근 기록이 삭제되었습니다',
    restDeleted: '휴식 기록이 삭제되었습니다',
    dataSaved: '데이터가 저장되었습니다',
    dataLoaded: '데이터가 로드되었습니다',
    dataImported: '데이터가 가져와졌습니다',
    dataExported: '데이터가 내보내졌습니다',
    noLocalData: '로컬 데이터를 찾을 수 없습니다. 기본 데이터를 사용합니다',
    cleanupComplete: '정리 완료, {{count}}개의 중복 기록을 제거했습니다',
    overtimeRecordAdded: '야근 기록 추가 성공!',
    restRequestSubmitted: '휴식 신청 제출 성공!',
    pleaseCompleteTimeInfo: '시간 정보를 완전히 입력해주세요',
    overtimeRecordUpdated: '야근 기록 업데이트 성공!',
    restRecordUpdated: '휴식 기록 업데이트 성공!',
    annualLeaveRecordUpdated: '연차 기록 업데이트 성공!',
    copiedToClipboard: '클립보드에 복사되었습니다',
    copyFailed: '복사에 실패했습니다. 다시 시도해주세요'
  },

  // 모달
  modals: {
    recordOvertimeTitle: '야근 기록',
    requestRestTitle: '휴식 신청',
    setAnnualLeaveTitle: '🏖️ 연차 일수 설정',
    editOvertimeTitle: '야근 기록 편집',
    editRestTitle: '휴식 기록 편집',
    editAnnualLeaveTitle: '연차 기록 편집',
    recordOvertimeTimeTitle: '⏱️ 야근 시간 기록',
    requestRestTimeTitle: '😴 휴식 시간 신청'
  },

  // 폼
  forms: {
    currentAnnualLeave: '현재 연차:',
    remainingTime: '남은 시간:',
    customDays: '사용자 정의 일수:',
    enterDays: '일수 입력',
    noAnnualLeave: '연차 없음',
    annualLeaveStartTime: '연차 시작 시간:',
    annualLeaveEndTime: '연차 종료 시간:',
    overtimeStartTime: '야근 시작 시간:',
    overtimeEndTime: '야근 종료 시간:'
  },

  // 테마 관련
  theme: {
    toggle: '테마 전환',
    modern: '모던 스타일',
    retro: '레트로 스타일',
    sketch: '스케치 스타일',
    damaged: '전손 스타일',
    switchToModern: '모던 스타일로 전환',
    switchToRetro: '레트로 스타일로 전환',
    switchToSketch: '스케치 스타일로 전환',
    switchToDamaged: '전손 스타일로 전환'
  }
};

export default koKRTranslations;
